import React, { Component } from "react";

import Cookies from "universal-cookie";
import { Buffer } from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import { UploadBillKPBStates } from "./types/UploadBillKPBTypes";
import { workshopService } from "../../services/bengkel/WorkshopService";
import SelectDealer from "../../components/dealer/select-dealer.component";
import withAuth from "../../hoc/withAuth";
import { Button, Form, Col, Row, Modal, Table } from "antd";
import { SaveOutlined, ReloadOutlined } from "@ant-design/icons";
import { HotTable } from "@handsontable/react";

export interface UploadBillKPBProps {}

class UploadBillKPB extends Component<UploadBillKPBProps & any, UploadBillKPBStates> {
  private readonly initState!: UploadBillKPBStates;
  private readonly id: string;
  private token = new Cookies().get("_t");
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
  private readonly hotSettings: any;
  private readonly hotTableComponent: React.RefObject<any>;

  constructor(props: (UploadBillKPBProps & any) | any) {
    super(props);

    this.initState = {
      user: this.user,
      processing: false,
      processingFetchTableData: true,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      dataConfig: [],
      pageSize: 500,
      modalAddWarehouse: false,
      addProcessing: false,
      checkboxSame: true,

      WorkshopCode: "",
      WorkshopName: "",
      ServiceList: [],
    };
    this.state = { ...this.initState };

    this.id = "hot";

    this.hotSettings = {
      rowHeaders: true,
      colWidths: 150,
      width: "100%",
      height: 400,
      colHeaders: ["No WO", "Nomor Dokumen", "Harga Biaya"],
      columns: [
        { data: "service_code", type: "text", width: 300 },
        { data: "no_document", type: "text", width: 300 },
        { data: "cost", type: "text", width: 300 },
      ],
    };
    this.hotTableComponent = React.createRef();
  }

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      processingFetchTableData: true,
      dealerCode: data.value,
    });
  };

  async componentDidMount() {
    const cookies = new Cookies();
    const token = cookies.get("_t");
    if (token) {
      const user = JSON.parse(Buffer.from(cookies.get("_u"), "base64").toString());
      await this.promisedSetState({
        user: user,
      });

      // console.log(this.state.user);
    }
  }

  onClickSave = async () => {
    const dataTable = this.hotTableComponent.current.hotInstance.getData();
    const serviceList = [];
    for (const row of dataTable) {
      const service_code = row[0];
      const no_document = row[1];
      const cost = row[2];

      if (no_document && Number(cost) > 0) {
        serviceList.push({
          no_document: no_document,
          cost: Number(cost),
          service_code: service_code,
        });
      }
    }

    if (this.state.WorkshopCode === "") {
      Modal.error({
        title: "Proses Gagal",
        content: "Data tidak lengkap [Workshop Code]",
      });
      return false;
    }

    const input = {
      workshop_code: this.state.WorkshopCode,
      workshop_name: this.state.WorkshopName,

      data_kpb: serviceList,

      updated_by: this.state.user,
      platform: "app-web",
      source: "otodis-upload-bill-kpb",
    };

    if (serviceList?.length < 1) {
      Modal.error({
        title: "Proses Gagal",
        content: "Data tidak lengkap",
      });
      await this.promisedSetState({
        processing: false,
      });
      return;
    } else {
      await this.promisedSetState({
        processing: true,
      });

      try {
        // console.log(input);
        workshopService.setToken(this.token);
        const uploadKPB = await workshopService.uploadBillKPB(input);
        // const uploadKPB = {
        //   data: {
        //     success: true,
        //     message: "SUCCESS",
        //     dataMessage: [],
        //     dataBill: {
        //       "KPB-D/001/06/2023/12293/KCCB": {
        //         no_document: "KPB-D/001/06/2023/12293/KCCB",
        //         total_bill: 975180,
        //         total_unit: 43,
        //       },
        //       "KPB-D/002/06/2023/12293/KCCB": {
        //         no_document: "KPB-D/002/06/2023/12293/KCCB",
        //         total_bill: 883960,
        //         total_unit: 43,
        //       },
        //       "KPB-D/003/06/2023/12293/KCCB": {
        //         no_document: "KPB-D/003/06/2023/12293/KCCB",
        //         total_bill: 942500,
        //         total_unit: 44,
        //       },
        //       "KPB-D/004/06/2023/12293/KCCB": {
        //         no_document: "KPB-D/004/06/2023/12293/KCCB",
        //         total_bill: 826580,
        //         total_unit: 45,
        //       },
        //     },
        //   },
        // };
        const dataMessage = uploadKPB.data.dataMessage;
        const dataBill: any = uploadKPB.data.dataBill;
        const tableSource = [];

        if (Object.keys(dataMessage).length > 0) {
          dataMessage.map((message: string) =>
            tableSource.push({
              no_document: "",
              total_bill: "",
              total_wo: "",
              pesan: message,
              status: "ERROR",
            })
          );
        }

        if (Object.keys(dataBill).length > 0) {
          for (const key in dataBill) {
            const { no_document, total_bill, total_unit } = dataBill[key];
            tableSource.push({
              no_document,
              total_bill,
              total_wo: total_unit,
              pesan: "SUCCESS",
              status: "SUCCESS",
            });
          }
        }

        const tableColumns = [
          {
            title: "No Dokumen",
            dataIndex: "no_document",
            key: "no_document",
          },
          {
            title: "Total Bill",
            dataIndex: "total_bill",
            key: "total_bill",
          },
          {
            title: "Total WO",
            dataIndex: "total_wo",
            key: "total_wo",
          },
          {
            title: "Pesan",
            dataIndex: "pesan",
            key: "pesan",
            render: (text: string, record: any) => {
              if (record.status === "ERROR") {
                return <span style={{ color: "red" }}>{text}</span>;
              }
              return text;
            },
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (text: string, record: any) => {
              if (record.status === "ERROR") {
                return <span style={{ color: "red" }}>{text}</span>;
              }
              return text;
            },
          },
        ];

        const tableContent = <Table dataSource={tableSource} columns={tableColumns} pagination={false} />;

        Modal.success({
          title: "Berhasil di Upload",
          content: tableContent,
          width: "50%",
        });

        this.setState(this.initState);
        this.onClickRefreshTable();
      } catch (e) {
        Modal.error({
          title: "Proses Gagal",
          content: "Error Server : " + e,
        });
        await this.promisedSetState({
          processing: false,
        });
      }
    }
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  onWorkshopChange = (v: string, i: any) => {
    console.log("onWorkshopChange", i);

    this.setState({
      WorkshopCode: v,
      WorkshopName: i.children,
    });
  };

  onClickRefreshTable = () => {
    let emptyData = [];
    this.hotTableComponent.current.hotInstance.loadData([]);
    for (let i = 0; i < 15; i++) {
      emptyData.push(["", "", "", "", "", "", "", "", "", "", "", "", ""]);
    }
    this.hotTableComponent.current.hotInstance.loadData(emptyData);
    console.log("countRows", this.hotTableComponent.current.hotInstance.countRows());

    this.setState({
      processing: false,
    });
  };

  render() {
    return (
      <React.Fragment>
        <MainLayout
          noPadNoMar={true}
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Stock`}
          breadcrumbMenu={`Upload Bill KPB`}
          defaultSelectedKeys={["m-upload-bill-kpb"]}
          defaultOpenKeys={["sm-bengkel"]}
        >
          <Form layout="vertical">
            <Row style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 10 }}>
              <Col xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <SelectDealer label="Nama Bengkel" value={this.state.WorkshopCode} onChangeValue={this.onWorkshopChange}></SelectDealer>
              </Col>
            </Row>

            <Row style={{ paddingLeft: 10, paddingRight: 10 }}>
              <Col xl={{ span: 3 }} lg={{ span: 6 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item>
                  <Button type={"primary"} icon={<SaveOutlined />} loading={this.state.processing} onClick={this.onClickSave} style={{ width: "100%" }}>
                    Simpan Data
                  </Button>
                </Form.Item>
              </Col>

              <Col xl={{ span: 3 }} lg={{ span: 6 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item>
                  <Button
                    onClick={this.onClickRefreshTable}
                    type="primary"
                    icon={<ReloadOutlined />}
                    style={{ background: "#ca2e2e", borderColor: "#ca2e2e", width: "100%" }}
                    loading={this.state.processing}
                  >
                    Refresh Table
                  </Button>
                </Form.Item>
              </Col>

              <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <HotTable ref={this.hotTableComponent} id={this.id} settings={this.hotSettings} />
              </Col>
            </Row>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(UploadBillKPB), 48);
